import { render } from "./MiniMetodeStandardPage.vue?vue&type=template&id=1fc339e5"
import script from "./MiniMetodeStandardPage.vue?vue&type=script&lang=js"
export * from "./MiniMetodeStandardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__